import Vue from 'vue'
import './utils/axios'
import App from './App.vue'
import router from './router' // Changed import
import store from './store'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import './assets/global.css';
import request, { baseURL } from "@/utils/request"
import i18n from './i18n'
import 'element-ui/lib/theme-chalk/index.css';
import '@fortawesome/fontawesome-free/css/all.css';

Vue.config.productionTip = false

Vue.use(ElementUI, {
  size: "mini",
  i18n: (key, value) => i18n.t(key, value)
});

Vue.prototype.request=request
Vue.prototype.$hostURL=baseURL

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
